export const PLAN_ROW_APPLY = 'apply';
export const PLAN_ROW_SKIP = 'skip';
export const PLAN_ROW_CONFLICT = 'conflict';
export const PLAN_ROW_IDENTITY = 'identity';
export const PLAN_PAGE_SIZE = 25;
export function planRowKind(row) {
    const kind = row.rowKind;
    if (kind === PLAN_ROW_SKIP || kind === PLAN_ROW_CONFLICT || kind === PLAN_ROW_IDENTITY) {
        return kind;
    }
    if (row.action === 'skip') return PLAN_ROW_SKIP;
    if (row.action === 'identity') return PLAN_ROW_IDENTITY;
    return PLAN_ROW_APPLY;
}
/** A row that files on Accept. A duplicate files only when it has a
 *  destination ("File anyway"); one with nowhere to go is information. */ export function isPlanWriteRow(row) {
    const kind = planRowKind(row);
    if (kind === PLAN_ROW_CONFLICT) return Boolean(row.action?.trim());
    return kind === PLAN_ROW_APPLY;
}
export function rowProgramId(row, fallback = '') {
    const params = row.params ?? {};
    const fromParams = params.program_id ?? params.programId;
    if (typeof fromParams === 'string' && fromParams.trim()) {
        return fromParams.trim();
    }
    return fallback;
}
export function planReceiptText(input) {
    const parts = [
        `${input.received} received`
    ];
    parts.push(`${input.filed} filed`);
    if (input.skipped) parts.push(`${input.skipped} skipped`);
    if (input.conflicts) parts.push(`${input.conflicts} already filed`);
    if (input.identity) parts.push(`${input.identity} need a decision`);
    if (input.failed) parts.push(`${input.failed} failed`);
    return parts.join(' · ');
}
export function groupPlanRows(rows) {
    const buckets = {
        apply: [],
        conflict: [],
        identity: [],
        skip: []
    };
    rows.forEach((row, index)=>{
        buckets[planRowKind(row)].push({
            row,
            index
        });
    });
    return [
        {
            kind: PLAN_ROW_APPLY,
            title: 'To file',
            rows: buckets.apply
        },
        {
            kind: PLAN_ROW_CONFLICT,
            title: 'Already filed',
            rows: buckets.conflict
        },
        {
            kind: PLAN_ROW_IDENTITY,
            title: 'Need a decision',
            rows: buckets.identity
        },
        {
            kind: PLAN_ROW_SKIP,
            title: 'Skipped',
            rows: buckets.skip
        }
    ].filter((g)=>g.rows.length > 0);
}
export function isSkippedResult(result) {
    return result?.status === 'skipped';
}
export function isPendingResult(result) {
    return !result || result.status === 'pending';
}
